export default {
  namespaced  : true,

  state       : {
    paths : {
      webApi  : {
        resend                : '/api/v1/auth/email/resend',
        emailConfirmation     : '/api/v1/auth/email/verify/:id',
        resetPasswordRequest  : '/api/v1/auth/password/email',
        resetPasswordPost     : '/api/v1/auth/password/reset',
        
        registration          : '/web-api/v1/auth/register',
        leave                 : '/api/v1/auth/leave',
      }
    }
  },

  actions     : {
    async emailConfirmationResend(context){
      return await context.dispatch('requests/apiRequest', {
        method      : 'get',
        requestPath : context.state.paths.webApi.resend,
      }, {root:true});
    },

    async emailConfirmation(context, payload){
      const requestPath = context.state.paths.webApi.emailConfirmation;

      return await context.dispatch('requests/apiRequest', {
        method      : 'get',
        requestPath : requestPath.replace(':id', payload.params.id),
        
        parameters  : {
          expires   : payload.params.expires,
          signature : payload.params.signature,
        }
      }, {root:true});
    },

    async resetPasswordRequest(context, payload){
      return await context.dispatch('requests/apiRequest', {
        method      : 'post',
        requestPath : context.state.paths.webApi.resetPasswordRequest,
        parameters  : {
          email     : payload.email,
        }
      }, {root:true});
    },

    async resetPasswordPost(context, payload){
      return await context.dispatch('requests/apiRequest', {
        method      : 'post',
        requestPath : context.state.paths.webApi.resetPasswordPost,
        parameters  : {
          token                 : payload.token,
          email                 : payload.email,
          password              : payload.password,
          password_confirmation : payload.password_confirmation
        }
      }, {root:true});
    },

    async registrationWithEmail(context, payload){
      const result = await context.dispatch('requests/apiRequest', {
        method      : 'post',
        requestPath : context.state.paths.webApi.registration,
        parameters  : {
          email                 : payload.email,
          name                  : payload.name,
          displayname           : payload.displayname,
          password              : payload.password,
          password_confirmation : payload.password_confirmation
        }
      }, {root:true});

      if(result.status === 200){
        await context.dispatch({
          type        : 'requests/auth/afterWebLoginSucceded',
          secureToken : result.data.secureToken,
        }, {root: true});
      }

      return result;
    },

    async leave(context, payload){
      return await context.dispatch('requests/apiRequest', {
        method      : 'post',
        requestPath : context.state.paths.webApi.leave,
        parameters  : {
          password  : payload.password,
        }
      }, {root:true});
    }
  }
}